import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import CKEditor from 'ckeditor4-react';
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Sanitize from '../Sanitize';

class EditSetupQuestion extends Component {
	
	constructor(props){
        super(props);
        MathJax.Hub.Config({
            tex2jax: {
                inlineMath: [['$', '$'], ['\\(', '\\)']],
                displayMath: [['$$', '$$'], ['\\[', '\\]']],
                jax: ["input/TeX", "input/MathML", "input/AsciiMath", "output/HTML-CSS", "output/NativeMML", "output/PreviewHTML"],
            },
            "HTML-CSS": {
                webFont: "TeX",
                automatic: false,
                matchFontHeight: true,
            },
            showMathMenu: false,
        });
		this.state = {
            acyear : '',
            accyear : [],
			_message : '',
            alertClass :'',
            posts : [],
            subject :[],
            lessons : [],
            data : [],
            questions : [],
            question : [],
            qusdata : [],
            btnText : 'Update',
			isview : false,
            _redirect : false,
            questionid : this.props.match.params.id
        }
        this.handleChange = this.handleChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onClsChange = this.onClsChange.bind(this);
		this.onSubChange = this.onSubChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
    }

    onQusChange(id,e){

        var d = this.state.qusdata;
        var noofqus = $("#noofquestion").val();
        var length = d.length;
        if(e.target.checked){
            if(length < noofqus){
                d.push({"id" : id});
            }
            else{
                var chkid = "#chk"+id;
                $(chkid).prop("checked",false);
                alert('Question Already Allocate');
            }
        }
        else{
            var index = d.findIndex(function(obj){
                return(obj.id == id);
            });
            if(index > -1){
                d.splice(index,1);
            }
        }
        this.setState({qusdata : d});
    }

    onViewClick(e){
        this.filterdata();
    }

    handleChange(value){
        this.setState({lesson : value});
    }

    onClsChange(e){
        $("#sub").val('');
        this.state.cls = e.target.value;
        var str = $("#clas").find(":selected").attr("data-name");
        this.state.clsname = str.includes("KG") ? str : str.substr(4,10);
		this.setState({[e.target.name]:e.target.value,isview : false});
		this.getsubject();
	}

    onSubChange(e){
        this.state.sub = e.target.value;
        this.state.subname = $("#sub").find(":selected").attr("data-name");
        this.setState({sub : e.target.value,isview : false});
        this.getlesson();
        this.getQuestion();
	}
    
    componentDidMount(){
        this.getacyear();
        this.getclass();
        this.getquestionsetup();
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }

    componentDidUpdate() {
        $("span.math-tex").closest("p").css("display", "inline");
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }
    
    getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

    /** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
    }
    
	getquestionsetup(){
		$("#showLoader").show();
		GetData('question/getquestionsetupbyid/'+this.props.match.params.id).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
                    data : responseJson,
                    acyear : responseJson[0].acyear,
                    cls : responseJson[0].class,
                    sub : responseJson[0].subject,
                    noofquestion : responseJson[0].noofquestions,
                    selection : responseJson[0].selection,
                    less : responseJson[0].lesson,
                    subname : responseJson[0].subname
                });
                this.state.clsname = responseJson[0].clsname.includes("KG") ? responseJson[0].clsname : responseJson[0].clsname.substr(4,10);
                this.getsubject();
                this.getlesson();
                this.getQuestion();
                var dat = [];
                responseJson.map((item,i)=>{
                    dat.push({"id" : item.question});
                });
                this.setState({qusdata : dat});
			}
		});
	}
    
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** submit form **/
	onSubmit(e){
        e.preventDefault();
        $("#showLoader").show();
		this.setState({btnText : 'Updating...'})
        PostData('question/editquestionsetup',this.state).then((result) => {
            let responseJson = result;
            if(responseJson.status == '1' ){
                this.setState({
                    _message:'Question Updated Successfully!..',
                    alertClass:'alert alert-success',
                    btnText : 'Update',
                });
            }
            else{
        
                this.setState({
                    _message:'Invalid Key',
                    alertClass:'alert alert-danger'
                });
            }
            $("#showLoader").hide();
        });
	}
    
    getsubject(){
	
        $("#showLoader").show();
        if(this.state.userRole == 'admin'){
            GetData('assignsubject/getsubbycls/'+this.state.acyear+'/'+this.state.cls).then((result) => {
                $("#showLoader").hide();
                let responseJson = result;
                if(responseJson){
                    this.setState({
                        subject : responseJson
                    });
                }
            });
        }
        else if(this.state.userRole == 'questionbank'){
			GetData('assignsubject/getsubbystaff/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						subject : responseJson
					});
				}
			});
		}
	}
    
    getlesson() {
		$("#showLoader").show();
		GetData('question/getlessonsbysub/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.sub).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					lessons: responseJson
                });
                
                var lessonArr = this.state.less.split(',');
                var dat = [];
                for(var j=0;j<responseJson.length;j++){
                    for(var i=0;i<lessonArr.length;i++){
                        if(responseJson[j].id == lessonArr[i]){
                            dat.push({"value" : responseJson[j].id, "lesson" : responseJson[j].lesson, "label" : (responseJson[j].bookname+'-'+responseJson[j].lesson)})
                        }
                    }
                }
                this.setState({lesson : dat});
			}
		});
    }
    
    getQuestion(){
        $("#showLoader").show();
		GetData('question/getquestionbysub/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.sub).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					questions: responseJson
                });
                this.filterdata();
			}
		});
    }

    filterdata(){
        var d = this.state.questions;
        var dat = [];
        for(var i=0;i<d.length;i++){
            for(var j=0;j<this.state.lesson.length;j++){
                if(d[i].lesson ==this.state.lesson[j].value ){
                    dat.push(d[i]);
                }
            }
        }
        this.setState({question : dat});
    }

    checkQuestion(id){
        var d = this.state.qusdata;
        var index = d.findIndex(function(obj){
            return(obj.id == id);
        });
        if(index > -1){
            return true;
        }
        else{
            return false;
        }
    }

    render() {
     
    var items = this.state.posts;
    var acyear = this.state.accyear;

    let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state.userId = userData['userid'];
    this.state.userRole = userData['userrole'];
	this.state.staffid = userData['staffid'];
    
    var less = this.state.lessons.map(function(e,key) {
        return (
          {value : e.id, lesson : e.lesson, label : (e.bookname+'-'+e.lesson)}
        );
     });
	
    return (<div>
        <QuestionPage />
        <div className="animated fadeIn">
            <Row>
                <Col md="12">
                <div className={this.state.alertClass}>
                    {this.state._message}
                </div>
                <Card>
                    <CardHeader>
                        <strong>Edit Setup Question</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Academic Year : &nbsp;&nbsp;
                        <select name="acyear" onChange={this.onacChange} required id="year">
                            <option value="">Select</option>
                            {
                                acyear.map(function (item) {
                                    return <option value={item.id }>{item.value}</option>;
                                })
                            }
                        </select>
                        <Link to="/questions/setup" className="btn btn-primary" style={{float : 'right'}}>List</Link>
                    </CardHeader>
                    <CardBody id="asubbody">
                        <form action="" method="post" role="form" id="addqus" encType="multipart/form-data" onSubmit={this.onSubmit} >
                        <Row>
                            <Col md="2">
                                <Label>Class <span className="text-danger">*</span></Label>
                                <select name="cls" onChange={this.onClsChange} id="clas" className="form-control" value={this.state.cls} required > 
                                    <option value="">Select Class</option>
                                    {
                                        items.map(function (item) {
                                            return <option value={item.id} data-name={item.class}>{item.class}</option>;
                                        })
                                    }
                                </select>
                            </Col>
                            <Col md="3">
                                <Label>Subject <span className="text-danger">*</span></Label>
                                <select name="sub" onChange={this.onSubChange} id="sub" className="form-control" value={this.state.sub} required > 
                                    <option value="">Select Subject</option>
                                    {
                                        this.state.subject.map(function (item) {
                                            return <option value={item.subject} data-name={item.prefix}>{item.sub}</option>;
                                        })
                                    }
                                </select>
                            </Col>
                            <Col md="3">
                                <Label>Lesson <span className="text-danger">*</span></Label>
                                <Select value={this.state.lesson} id="lesson" onChange={this.handleChange} multi options={less} required/>
                            </Col>
                            <Col md="2">
                                <Label>No.Of Question <span className="text-danger">*</span></Label>
                                <Input type="text" name="noofquestion" id="noofquestion" onChange={this.onChange} value={this.state.noofquestion} required />
                            </Col>
                            <Col md="2">
                                <Label>Selection Process <span className="text-danger">*</span></Label>
                                <select name="selection" className="form-control" onChange={this.onChange} value={this.state.selection} required>
                                    <option value="">Select</option>
                                    <option value="random">Random</option>
                                    <option value="manual">Manual</option>
                                </select>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                {this.state.selection == 'random'  || (this.state.selection == 'manual' && this.state.qusdata.length != 0) ?
                                    <Button type="submit" color="success" style={{float : 'right'}} disabled={this.state.btnText == 'Update' ? false : true}>{this.state.btnText}</Button> : ''}&emsp;
                                    {this.state.selection == 'manual' && this.state.qusdata.length == 0  ? 
                                    <Button type="button" color="primary" style={{float : 'right'}} onClick={this.onViewClick.bind(this)}>Run</Button> : ''}&emsp;
                                </FormGroup>
                            </Col>
                        </Row>
                        {this.state.selection == 'manual' ? 
                        <Row>
                            <Col md={12}>
                                <Table responsive bordered>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Check</th>
                                            <th>Question</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.question.map((item,i)=>
                                            <tr>
                                                <td>{i+1}</td>
                                                <td><input type="checkbox" id={"chk"+item.id} checked={this.checkQuestion(item.id)} onChange={this.onQusChange.bind(this,item.id)} /></td>
                                                <td><div dangerouslySetInnerHTML={{ __html: item.question }}></div></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row> : ''}
                        </form>
                    </CardBody>
                </Card>
                </Col>
            </Row>
        </div>
        </div>
	)
  }
}

export default EditSetupQuestion;



// WEBPACK FOOTER //
// ./src/Questions/EditSetupQuestion.js